import { Injectable } from '@angular/core';

import * as CryptoJS from 'crypto-js';
import * as _ from 'lodash-es';

import Resources from '../../core/constants/resources';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  private data: any = {};

  constructor() { }

  // Store into global variable as well as client session
  setItemIntoMemory(key: string, value: any): void {
    if (!this.data) {
      this.data = {};
    }

    // Store into variable
    if (!Object.keys(this.data).includes(key)) {
      this.data = _.assign(this.data, { [key]: value });
    } else {
      this.data[key] = value;
    }

    // Store into client session
    sessionStorage.setItem(key, (typeof value == 'string') ? value : JSON.stringify(value));
  }

  // Get item from global variable as well as client session
  getItemFromMemory(key: string): any {
    // Get from stored variable
    if (!!this.data && !!this.data[key]) {
      return this.data[key];
    } else if (!!sessionStorage.getItem(key)) {
      // Get from client session
      try {
        this.data[key] = JSON.parse(sessionStorage.getItem(key));
        return JSON.parse(sessionStorage.getItem(key));
      } catch (e) {
        this.data[key] = sessionStorage.getItem(key);
        return sessionStorage.getItem(key)
      }
    }
  }

  // Remove Item from global variable as well as client session
  removeItemFromMemory(key: string): void {
    // Delete from variable
    if (!!this.data && !!this.data[key]) {
      delete this.data[key];
    }
    // Remove from client session
    if (!!sessionStorage.getItem(key)) {
      sessionStorage.removeItem(key);
    }
  }

  // Store into client local storage
  setItemIntoLocalStorage(key: string, value: any): void {
    localStorage.setItem(key, (typeof value == 'string') ? value : JSON.stringify(value));
  }

  // Get item from client local storage
  getItemFromLocalStorage(key: string): any {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (e) {
      return localStorage.getItem(key);
    }
  }

  // Remove Item from client local storage
  removeItemFromLocalStorage(key: string): void {
    localStorage.removeItem(key);
  }

  // Encrypt session value and store into global variable and client session
  setItemIntoSessionEncrypted(key: string, value: any): void {
    let keys = CryptoJS.SHA256(key, Resources.SessionKey.key).toString();
    let values = CryptoJS.AES.encrypt(
      JSON.stringify(value),
      Resources.SessionKey.key
    ).toString();
    this.setItemIntoMemory(keys, values);
  }

  // Decrypt session value from global variable and client session then value return
  getItemFromSessionDecrypted(key: string): any {
    let keys = CryptoJS.SHA256(key, Resources.SessionKey.key).toString();
    let value = '';

    if (!!this.data && !!this.data[keys]) {
      value = this.data[keys];
    } else if (!!sessionStorage.getItem(keys)) {
      this.data[keys] = sessionStorage.getItem(keys);
      value = sessionStorage.getItem(keys);
    }

    if (typeof value !== 'string') {
      return value;
    }
    if (!!value) {
      value = CryptoJS.AES.decrypt(value, Resources.SessionKey.key).toString(
        CryptoJS.enc.Utf8
      );
      return JSON.parse(value);
    }
    return value;
  }

  // Remove Encrypted Data from global variable as well as client session
  removeEncryptDataFromSession(key: string) {
    let keys = CryptoJS.SHA256(key, Resources.SessionKey.key).toString();
    this.removeItemFromMemory(keys);
  }

  // Reset storage from global variable as well as client session based on optional condition
  resetStorage(option?): void {
    if (option === 'session') {
      sessionStorage.clear();
    } if (option === 'data') {
      this.data = undefined;
    } else {
      sessionStorage.clear();
      this.data = undefined;
    }
  }
}

